/** Reporter-standing client: reads the corroboration service's humanized
 *  /standing/{did} (capability + progress). Read-only; no signing. */
export type Capability = "direct" | "needs-confirmation";

export interface Standing {
  capability: Capability;
  // Active corroboration profile. When raw BEACON_* overrides are applied the
  // server suffixes the name (e.g. "canonical+overrides"); informational only.
  profile: "open" | "corroborate" | "canonical" | (string & {});
  progress: { confirmedRemaining: number; presenceDaysRemaining: number; ageDaysRemaining: number };
  asOf: number;
}

export interface StandingClientOptions {
  baseUrl: string;
  fetchImpl?: typeof fetch;
}

export class StandingClient {
  constructor(private readonly opts: StandingClientOptions) {}

  private get fetch(): typeof fetch {
    return this.opts.fetchImpl ?? globalThis.fetch.bind(globalThis);
  }

  async standing(did: string): Promise<Standing> {
    const res = await this.fetch(`${this.opts.baseUrl}/standing/${did}`);
    if (!res.ok) throw new Error(`standing fetch failed: ${res.status} ${res.statusText}`);
    return (await res.json()) as Standing;
  }
}
